import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { StyledUILink } from '../../styles/TextInput.styles';
import { isCanvasTheme, useTheme } from 'foundations-theming/utils';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HaveAnAccountLink = ({
  href,
  accountLinkMessage = 'button.haveAnAccountLink',
  onClick = () => {}
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isCanvasTheme(theme) ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: accountLinkMessage
      }), /*#__PURE__*/_jsx(Link, {
        href: href,
        onClick: onClick,
        "data-selenium": "signin-link",
        children: /*#__PURE__*/_jsx(StyledUILink, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: 'button.signIn'
          })
        })
      })]
    }) : /*#__PURE__*/_jsxs(TFlex, {
      alignItems: "baseline",
      gap: 4,
      flexWrap: "nowrap",
      whiteSpace: "nowrap",
      justifyContent: "center",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "div",
        typography: "body-200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: accountLinkMessage
        })
      }), /*#__PURE__*/_jsx(Button, {
        href: href,
        use: "transparent",
        onClick: onClick,
        "data-selenium": "signin-link",
        padding: "0",
        children: /*#__PURE__*/_jsx(Text, {
          as: "div",
          typography: "heading-100",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: 'button.signIn'
          })
        })
      })]
    })
  });
};